import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";
import { WeekDays } from "src/client/react/src/staffhub/sh-models";

export default mutatorAction("updateRepeatOnSmartScheduleShift", function updateRepeatOnSmartScheduleShift(repeatOn: WeekDays[]) {
    if (shiftEditorViewState().smartScheduleShift && repeatOn) {
        shiftEditorViewState().smartScheduleShift.repeatOn = repeatOn;
    }
});